/**
 * Pass alerts chart data
 * @param data the data to extract chart data from
 * @returns list of Dates / Mean / Min-Max Range
 */
const makeChartData = data => {
  const meanData = data.map(x => {
    return [x.date_time, x.mean];
  });

  const minMaxRangeData = data.map(x => {
    return [x.date_time, x.min, x.max];
  });

  return {
    meanData,
    minMaxRangeData
  };
};

const formatPoint = (minMaxRange, yUnit = "") => {
  return function() {
    const roundToTwo = num => Math.round(num * 100 + Number.EPSILON) / 100;

    const [, min, max] = minMaxRange[this.index];
    return `Max : ${roundToTwo(max)}${yUnit}<br/><strong>${
      this.series.name
    }: ${roundToTwo(this.y)}${yUnit}</strong><br/>Min: ${roundToTwo(
      min
    )}${yUnit}`;
  };
};

const getChartOptions = (
  rule_name,
  levelTypeColor,
  meanData,
  minMaxRangeData,
  thresholds,
  yAxisTitle,
  yUnit
) => {
  return {
    title: {
      text: rule_name ?? "",
      align: "left"
    },
    series: [
      {
        name: "Mean",
        type: "line",
        color: levelTypeColor,
        data: meanData,
        label: {
          enabled: false
        },
        tooltip: {
          //Custom function for showing the min and max values on mean tooltip
          //without having to use a shared tooltip
          pointFormatter: formatPoint(minMaxRangeData, yUnit),
          enabled: false
        },
        zIndex: 2
      },
      {
        name: "Min-max range",
        type: "arearange",
        color: levelTypeColor,
        data: minMaxRangeData,
        label: {
          enabled: false
        },
        opacity: 0.4,
        marker: {
          enabled: false
        },
        enableMouseTracking: false,
        lineWidth: 0,
        zIndex: 1
      },
      ...thresholds
    ],
    plotOptions: {
      series: {
        label: {
          enabled: true
        },
        marker: {
          symbol: "circle",
          lineWidth: 2,
          fillColor: "white",
          lineColor: null
        }
      }
    },
    tooltip: {
      valueDecimals: 2
    },
    xAxis: {
      type: "datetime",
      title: {
        text: "Date"
      }
    },
    yAxis: {
      title: {
        text: yAxisTitle
      }
    }
  };
};

export const getAggregateChartOptions = (
  alertColour,
  data,
  tagUnit,
  tagName,
  ruleName,
  thresholds,
  yAxisTitle
) => {
  let { meanData, minMaxRangeData } = makeChartData(data);

  return getChartOptions(
    ruleName,
    alertColour,
    meanData,
    minMaxRangeData,
    thresholds,
    yAxisTitle,
    tagUnit
  );
};
